import ProSearch from '../ProSearch';
import QuickOrder from '../QuickOrder';
import Favorites from '../Favorites';
import Enquiry from '../Enquiry';
import Contact from '../Contact';
import Language from '../Language';

export const components = {
  ProSearch,
  QuickOrder,
  Favorites,
  Enquiry,
  Contact,
  Language,
};
